import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import InputGroup from './InputGroup.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'InputGroup',
    multi: false
  })
)
export class DetailStringInputGroupFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(InputGroup);
    return this;
  }
}